import React, { useContext } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Divider, Avatar } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { useNavigate } from "react-router-dom";
import { config } from '../../App';

const Sidemenu = (props) => {
    const { closeMenu } = props.value;
    const navi = useNavigate();
    const { userType, signout } = useContext(config);

    let menu = [
        { title: 'Manage Organization', secTitle: 'Manage all Organization here.', onclick: '/orgs/list', admin: true, icon: 'AddCircleIcon' },
        { title: 'Manage Users', secTitle: 'Manage all Users here.', onclick: '/users', admin: true, icon: 'AddCircleIcon' },
        { title: 'Manage PrivateDB', secTitle: 'Manage all Private DB here.', onclick: '/privatedb', admin: true, icon: 'AddCircleIcon' },
        { title: 'Recalls From Ustires.org', secTitle: 'Recalls From 2000-23 ustires.org', onclick: '/ustires/list', admin: true, icon: 'AddCircleIcon' },
        { title: 'DOT Research', secTitle: 'Logs of how DOT details are searched', onclick: '/dot/research', admin: true, icon: 'AddCircleIcon' },
        // {title: 'Manage Size Codes', secTitle: 'Manage all size codes here', onclick: '/size/list', admin: true, icon: 'AddCircleIcon'},
        // {title: 'Manage Plant Codes', secTitle: 'Manage all Plant codes here', onclick: '/plant/list', admin: true, icon: 'AddCircleIcon'},
        // {title: 'Manage Packages', secTitle: 'Manage all Packages here.', onclick: '', admin: true, icon: 'AddCircleIcon'},
        // {title: 'Manage Roles', secTitle: 'Manage all Roles here', onclick: '', admin: true, icon: 'AddCircleIcon'},
    ];

    if (userType === 'Normal User') {
        menu = menu.filter(a => !a.admin || a.admin === 'both');
    } else {
        menu = menu.filter(a => a.admin || a.admin === 'both');
    }

    const handleclick = func => {
        console.log(func);
        navi(func);
        closeMenu()
    }

    const sot = () => {
        closeMenu();
        navi('/');
        signout()
    }

    return (
        <List sx={{ minWidth: '300px' }}>
            <ListItem button onClick={() => handleclick('/')}>
                <ListItemIcon>
                    <KeyboardBackspaceIcon />
                </ListItemIcon>
                <Avatar variant="square" color="success" src="https://tirefax.s3.us-west-2.amazonaws.com/images/tirefax.png"
                    sx={{
                        width: "190px",
                        height: "80px",
                        backgroundColor: "#eeeeee",
                        borderRadius: "10px"
                    }}
                />
            </ListItem>
            <Divider />
            {
                menu.map((text, index) =>
                    <ListItem button key={text.title} onClick={() => handleclick(text.onclick)}>
                        <ListItemIcon sx={{ minWidth: '40px' }}><AddCircleIcon /></ListItemIcon>
                        <ListItemText primary={text.title} secondary={text.secTitle} />
                    </ListItem>
                )
            }
            <Divider />
            <ListItem button onClick={() => sot()}>
                <ListItemIcon sx={{ minWidth: '40px' }}><PowerSettingsNewIcon /></ListItemIcon>
                <ListItemText primary='Sign Out' />
            </ListItem>
        </List>
    )
}

export default Sidemenu;